import { EnvironmentProviders, Provider } from '@angular/core';
import { HttpInterceptorFn, provideHttpClient, withInterceptors } from '@angular/common/http';
import { API_BASE_URL } from './api-base-url.token';
import { httpErrorInterceptor } from './http-error.interceptor';
import { timeoutInterceptor } from './timeout.interceptor';

export const provideCoreHttp = (
  apiBaseUrl = '/api',
  interceptors: HttpInterceptorFn[] = [],
): (Provider | EnvironmentProviders)[] => [
  { provide: API_BASE_URL, useValue: apiBaseUrl },
  provideHttpClient(withInterceptors([timeoutInterceptor, httpErrorInterceptor, ...interceptors])),
];
